import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { TipoClassificacao } from '../tipo-classificacao';
import { TipoClassificacaoCrudHttpService } from '../services';
import { TipoClassificacaoCadastroFilterPipe } from '../pipes';
import { TipoClassificacaoCadastro, tipoClassificacaoCadastros } from '../cadastro';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-tipo-classificacao-multiselect',
    templateUrl: './tipo-classificacao-multiselect.component.html',
    styleUrls: ['./tipo-classificacao-multiselect.component.less']
})
export class TipoClassificacaoMultiselectComponent implements OnInit, OnDestroy {
    /** Tipos selecionados */
    @Input() idsTiposClassificacoes: number[];
    /** Ao alterar a seleçãod os tipos */
    @Output() idsTiposClassificacoesChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de tipo de classificação nulo ou seja, para filtrar registros que não possuem o tipo de classificação */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar o tipo de classificação nulo */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção do tipo de classificação nulo */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    /** Ao destruir o multiselect */
    @Output() onDestroy = new EventEmitter<void>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Tipo de Segmento';
    @Input() checked = 'Tipo de Segmento';
    @Input() checkedPlural = 'Tipos de Segmentos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum tipo de segmento encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    // tiposClassificacoes: TipoClassificacao[] = [];

    constructor(private messageService: MessageService,
                private tipoClassificacaoCrudHttpService: TipoClassificacaoCrudHttpService,
                private tipoClassificacaoCadastroFilterPipe: TipoClassificacaoCadastroFilterPipe,
                private upperCasePipe: UpperCasePipe) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-tipo-classificacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de classificações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.tipoClassificacaoCrudHttpService.search()
            .pipe(
                take(1)
            )
            .subscribe(
                tiposClassificacoes => {
                    // Adicionando os tipos e suas classificações ao multiselect
                    if (tiposClassificacoes) {
                        // Adicionando a opção de "Sem Tipo de Segmento"
                        if (this.showNullOption) {
                            selects.push({
                                id: 0,
                                name: 'SEM TIPO DE SEGMENTO'
                            });
                        }

                        // Criando e adicionando os selects options para multiselect agrupando os tipos de classificações pelos cadastros
                        tipoClassificacaoCadastros.forEach(cadastro => {
                            const selectsCadastro = this.createSelectOptions(tiposClassificacoes, cadastro);
                            selects.push(...selectsCadastro);
                        });

                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os tipos de segmentos', error);
                }
            );
    }

    /** Cria os selects options para o multiselect agrupando os tipos de classificações pelo cadastro informado */
    private createSelectOptions(tiposClassificacoes: TipoClassificacao[], cadastro: TipoClassificacaoCadastro): IMultiSelectOption[] {
        const selects: IMultiSelectOption[] = [];

        // Criando agrupamento
        selects.push({
            id: cadastro.id,
            name: this.upperCasePipe.transform(cadastro.nome),
            isLabel: true
        });

        // Adicionando os tipos filtrados pelo cadastro informado
        this.tipoClassificacaoCadastroFilterPipe.transform(tiposClassificacoes, cadastro.id)?.forEach(tipoClassificacao => {
            selects.push({
                id: tipoClassificacao.id,
                name: tipoClassificacao.nome
            });
        });

        return selects;
    }


    /** Ao alterar a seleção da opção de tipo de classificação nulo */
    private onChangeNullOption() {
        this.nullOption = this.idsTiposClassificacoes.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção dos tipos de classificações */
    onChange() {
        this.onChangeNullOption();
        this.idsTiposClassificacoesChange.emit(this.idsTiposClassificacoes);
    }

    ngOnDestroy() {
        this.onDestroy.emit();
    }
}
